import { api } from "../api";

export interface CatalogProductivityRow {
  staffUserId: string;
  book: number;
  journal: number;
  eResource: number;
  total: number;
}

export interface CatalogReportQuery {
  from?: string;
  to?: string;
}

export const catalogReportsApi = {
  getProductivity: async (params?: CatalogReportQuery): Promise<CatalogProductivityRow[]> => {
    const response = await api.get<CatalogProductivityRow[]>("/catalog/reports/productivity", {
      params,
    });
    return response.data;
  },

  getMyStats: async (params?: CatalogReportQuery): Promise<CatalogProductivityRow[]> => {
    const response = await api.get<CatalogProductivityRow[]>("/catalog/reports/my-stats", {
      params,
    });
    return response.data;
  },
};
